/** Propone por necesidad, antigüedad de pedido y UUID; conserva milésimas exactas. */
export const proposeReceiptAllocation = (items, articleId, total) => {
  let remaining = Math.round(Number(total) * 1000);
  if (!Number.isSafeInteger(remaining) || remaining < 0) return null;
  const rows = items.filter((row) => row.uuid_inventory_article === articleId).sort((a, b) =>
    (a.origin?.required_at || '9999').localeCompare(b.origin?.required_at || '9999')
    || (a.origin?.created_at || '9999').localeCompare(b.origin?.created_at || '9999')
    || a.uuid.localeCompare(b.uuid));
  const result = {};
  rows.forEach((row) => {
    const quantity = Math.min(remaining, Math.round(Number(row.pending_quantity) * 1000));
    result[row.uuid] = String(quantity / 1000);
    remaining -= quantity;
  });
  return remaining ? null : result;
};
